import React from 'react';
import { TableCellType } from '../ComparisonTableTypes';
import { RowHeader } from '../RowHeader/RowHeader';
import styles from './TableMobile.module.scss';
import { TableMobileCell } from './TableMobileCell';

export interface TableMobileProps {
  /** The table data structure */
  data: TableCellType[][];
}

export const TableMobile: React.FC<TableMobileProps> = ({ data }) => {
  return (
    <div className={styles.table_mobile}>
      {data.slice(1).map((row, rowIndex) => (
        <div key={rowIndex} className={styles.section}>
          <RowHeader
            title={row[0]?.title}
            bodyText={row[0]?.bodyText}
            cta={row[0]?.cta}
            align={row[0]?.title ? 'start' : 'center'}
          />
          <div className={styles.table_mobile_row}>
            {row.slice(1).map((cell, colIdx) => (
              <TableMobileCell
                key={colIdx}
                {...cell}
                className={colIdx == 0 ? styles.eb_cell : ''}
                cellTitle={data[0][colIdx + 1]}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
